export const LIST_ITEM_DATA_ATR = 'data-list-item';

export const GROUPED_ID_SEPARATOR = '-';

export const modToHeight = {
    s: [22, 44],
    m: [26, 44],
    l: [34, 52],
    xl: [44, 62],
} as const;
